// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const CoinIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Coin/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10 18.958c-3.333 0-6.042-2.391-6.042-5.333v-3.083a.63.63 0 0 1 .625-.625.63.63 0 0 1 .625.625c0 2.183 2.059 3.833 4.792 3.833 2.733 0 4.792-1.65 4.792-3.833a.63.63 0 0 1 .625-.625.63.63 0 0 1 .625.625v3.083c0 2.942-2.709 5.333-6.042 5.333Zm-4.792-5.241c.059 2.208 2.184 3.991 4.792 3.991 2.608 0 4.733-1.783 4.792-3.991-1.084 1.175-2.8 1.908-4.792 1.908s-3.7-.733-4.792-1.908Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10 11.458c-2.3 0-4.367-1.033-5.375-2.7a4.568 4.568 0 0 1-.667-2.383c0-1.433.642-2.783 1.8-3.8C6.892 1.583 8.4 1.042 10 1.042s3.1.541 4.242 1.525c1.158 1.025 1.8 2.375 1.8 3.808a4.59 4.59 0 0 1-.667 2.383c-1.008 1.667-3.075 2.7-5.375 2.7Zm0-9.166c-1.3 0-2.517.433-3.425 1.233-.883.767-1.367 1.783-1.367 2.85 0 .625.167 1.208.484 1.733.791 1.3 2.441 2.1 4.308 2.1s3.517-.808 4.308-2.1a3.24 3.24 0 0 0 .484-1.733c0-1.067-.484-2.083-1.375-2.867C12.508 2.725 11.3 2.292 10 2.292Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10 15.625c-3.442 0-6.042-2.183-6.042-5.083V6.375c0-2.942 2.709-5.333 6.042-5.333 1.6 0 3.1.541 4.242 1.525 1.158 1.025 1.8 2.375 1.8 3.808v4.167c0 2.9-2.6 5.083-6.042 5.083Zm0-13.333c-2.642 0-4.792 1.833-4.792 4.083v.833c0 2.184 2.059 3.834 4.792 3.834 2.733 0 4.792-1.65 4.792-3.834v-.833c0-1.067-.484-2.083-1.375-2.867C12.508 2.725 11.3 2.292 10 2.292Z"
}));
export default CoinIcon;